/**
 * Mirrors the Core enums used by booking configurations
 * (Org_ServiceFulfilmentConfig_Table). Values are sent as ints on
 * Create_ServiceFulfilmentConfig / Update_Org_ServiceFulfilmentConfig.
 *
 * Note every one of these starts at 1 = Unknown rather than 0, so a zero or a
 * missing value is not a valid state - it is a bug that will be stored.
 */
export const ACTIVATION_STATE = {
  UNKNOWN: 1,
  ACTIVE: 2,
  INACTIVE: 3,
} as const;

export const PREPAYMENT_REQUIRED = {
  UNKNOWN: 1,
  REQUIRED: 2,
  NOT_REQUIRED: 3,
} as const;

export const CONFIG_TYPE = {
  UNKNOWN: 1,
  BASIC: 2,
  ADVANCED: 3,
} as const;

export const QUEUE_ACTIVE = {
  UNKNOWN: 1,
  NOT_ACTIVE: 2,
  ACTIVE: 3,
} as const;

export const ORDER_STATE = {
  UNKNOWN: 1,
  PENDING: 2,
  CONFIRMED: 3,
  REJECTED: 4,
  IN_PROGRESS: 5,
  FULFILLED: 6,
  INVOICED: 7,
} as const;

export const activationOptions = [
  { title: "Active", value: String(ACTIVATION_STATE.ACTIVE) },
  { title: "Inactive", value: String(ACTIVATION_STATE.INACTIVE) },
];

export const prepaymentOptions = [
  { title: "Not required", value: String(PREPAYMENT_REQUIRED.NOT_REQUIRED) },
  { title: "Required", value: String(PREPAYMENT_REQUIRED.REQUIRED) },
];

export const configTypeOptions = [
  { title: "Basic", value: String(CONFIG_TYPE.BASIC) },
  { title: "Advanced", value: String(CONFIG_TYPE.ADVANCED) },
];

export const queueOptions = [
  { title: "No queue", value: String(QUEUE_ACTIVE.NOT_ACTIVE) },
  { title: "Queue enabled", value: String(QUEUE_ACTIVE.ACTIVE) },
];

export const getOrderStateLabel = (value: number | undefined) =>
  ({
    [ORDER_STATE.PENDING]: "Pending",
    [ORDER_STATE.CONFIRMED]: "Confirmed",
    [ORDER_STATE.REJECTED]: "Rejected",
    [ORDER_STATE.IN_PROGRESS]: "In progress",
    [ORDER_STATE.FULFILLED]: "Fulfilled",
    [ORDER_STATE.INVOICED]: "Invoiced",
  }[value ?? ORDER_STATE.UNKNOWN] ?? "Unknown");
